<template>
  <div class="service">
    <ul class="service-list">
      <li>
        <div class="item listen">
          <i class="material-icons icon item-icon">
            music_note
          </i>
          <h3 class="title">
            {{ $t('AIR.LISTEN_TITLE') }}
          </h3>
          <div class="content">
            <ul>
              <li v-for="(playlist, index) in playlistArray" :key="index">
                <i class="material-icons icon">
                  fiber_manual_record
                </i>
                <a :href="playlistHref(playlist)" target="_blank" rel="noopener noreferrer">
                  {{ playlist[$i18n.locale.toLowerCase()] }}
                </a>
              </li>
              <!-- <li v-for="(track, index) in tracksList" :key="index">
                <i class="material-icons icon">
                  fiber_manual_record
                </i>
                <a :href="trackHref(track)" target="_blank" rel="noopener noreferrer">
                  {{ displayWorkName(track && track.movement && track.movement.work) }}
                  {{ displayMovementName(track && track.movement) }}
                </a>
              </li> -->
            </ul>
          </div>
          <!-- <div class="content">
            <p class="desp">
              專為你打造的推薦清單，猜你喜歡聽！
            </p>
            <a class="listen-player" :href="listenHref" target="_blank" rel="noopener noreferrer">
              <PlayerStaticPlayBtn :width="clientWidth < 1440 ? 120 : 150" :height="clientWidth < 1440 ? 120 : 150" />
            </a>
          </div> -->
        </div>
      </li>
      <li>
        <div class="item read">
          <i class="material-icons icon">
            import_contacts
          </i>
          <h3 class="title">
            {{ $t('AIR.READ_TITLE') }}
          </h3>
          <div class="content">
            <ul>
              <li v-for="(article, index) in articleList" :key="index">
                <i class="material-icons icon">
                  fiber_manual_record
                </i>
                <a :href="articleHref(article)" target="_blank" rel="noopener noreferrer">
                  {{ article.subject }}
                </a>
              </li>
            </ul>
          </div>
        </div>
      </li>
      <li>
        <div class="item concert">
          <i class="material-icons icon">
            account_balance
          </i>
          <h3 class="title">
            {{ $t('AIR.CONCERT_TITLE') }}
          </h3>
          <div class="content">
            <ul>
              <li v-for="(event, index) in eventList" :key="index">
                <i class="material-icons icon">
                  fiber_manual_record
                </i>
                <a :href="eventHref(event)" target="_blank" rel="noopener noreferrer">
                  {{ event.title }}
                </a>
              </li>
            </ul>
          </div>
        </div>
      </li>
    </ul>
  </div>
</template>
<script>
import TrackService from '@/assets/services/TrackService'
import ArticleService from '@/assets/services/ArticleService'
import EventService from '../../assets/services/EventService'
// import PlayerStaticPlayBtn from '@/components/player/PlayerStaticPlayBtn'
import { displayWorkName } from '@/assets/helpers/WorkHelper'
import { displayMovementName } from '@/assets/helpers/MovementHelper'

export default {
  name: 'AIRServiceItem',
  components: {
    // PlayerStaticPlayBtn
  },
  directives: {},
  props: {},
  data() {
    return {
      trackIdArray: [
        '8ba896c1-899a-48ff-9514-c2c3b7c69c67',
        '8ba8d733-1e93-480e-9744-83eebfb6b825',
        '8ba8bc29-993f-4f01-abbc-6259e36c8fed',
        '8ba8e48b-2aa6-4dff-8f5a-9ce53ef88ee3',
        '8ba8d48a-1673-46b9-b384-caae8314909e',
        '8ba8c1af-e891-4f26-a500-82bf21119520'
      ],
      playlistArray: [{
        id: '8bab963a-41c3-4cad-ba55-ad34dc8a316d',
        'en-us': 'The best collection of piano solo',
        'ja-jp': 'The best collection of piano solo',
        'zh-tw': '精選鋼琴獨奏曲',
        'zh-cn': '精选钢琴独奏曲'
      }, {
        id: '8bab9630-0628-49c9-aad0-06c0b2b133df',
        'en-us': 'The best collection of Beethoven',
        'ja-jp': 'The best collection of Beethoven',
        'zh-tw': '貝多芬精選輯',
        'zh-cn': '贝多芬精选辑'
      }, {
        id: '8bab9565-b04f-4d55-9e81-3a6f4747de52',
        'en-us': 'The best collection of Mozart',
        'ja-jp': 'The best collection of Mozart',
        'zh-tw': '莫札特精選輯',
        'zh-cn': '莫札特精选辑'
      }, {
        id: '8bab952e-74dc-4aae-9a49-833343b17be5',
        'en-us': 'The best collection of Nodame Cantabile',
        'ja-jp': 'The best collection of Nodame Cantabile',
        'zh-tw': '電影《交響情人夢》精選輯',
        'zh-cn': '电影《交响情人梦》精选辑'
      }, {
        id: '8bab94b7-2c3d-4e53-9060-9f14e3ee7190',
        'en-us': 'The best collection of TITANIC',
        'ja-jp': 'The best collection of TITANIC',
        'zh-tw': '電影《鐵達尼號》精選輯',
        'zh-cn': '电影《铁达尼号》精选辑'
      }, {
        id: '8bab968d-b791-4d1e-b889-b31fede5bf92',
        'en-us': 'The best collection of String Quartet',
        'ja-jp': 'The best collection of String Quartet',
        'zh-tw': '精選弦樂四重奏',
        'zh-cn': '精选弦乐四重奏'
      }],
      tracksList: [],
      articleList: [],
      eventList: []
    }
  },
  computed: {
    clientWidth() {
      return this.$store.state.clientWidth
    },
    listenHref() {
      return `https://${process.env.VUE_APP_MUZIK_LISTEN}.${
        process.env.VUE_APP_MUZIK_DOMAIN
      }/${this.$i18n.localePath()}?autoplay=true`
    }
  },
  watch: {},
  created() {},
  mounted() {
    this.getTracks()
    this.getArticles()
    this.getEvents()
  },
  updated() {},
  methods: {
    displayWorkName,
    displayMovementName,
    async getTracks() {
      let res = await TrackService.getTracks({ id: this.trackIdArray })
      this.tracksList = res.data
      if (res) {
        this.tracksList = res.data
      } else {
        this.tracksList = null
      }
    },
    async getArticles() {
      let params = {
        per_page: 6,
        page: 1
      }
      params.sort = '-published_at'
      const res = await ArticleService.getArticles(params)
      if (res) {
        this.articleList = res.data
      } else {
        this.articleList = null
      }
    },
    async getEvents() {
      let res = await EventService.getEventList('', 1, 6, 'list')
      if (res && res.data) {
        this.eventList = res.data
      } else {
        this.eventList = null
      }
    },
    trackHref(track) {
      return track && track.id
        ? `https://${process.env.VUE_APP_MUZIK_LISTEN}.${
          process.env.VUE_APP_MUZIK_DOMAIN
        }/${this.$i18n.localePath()}/tracks/${track.id}`
        : `https://${process.env.VUE_APP_MUZIK_LISTEN}.${process.env.VUE_APP_MUZIK_DOMAIN}/${this.$i18n.localePath()}/`
    },
    articleHref(article) {
      return article && article.id
        ? `https://${process.env.VUE_APP_MUZIK_READ}.${
          process.env.VUE_APP_MUZIK_DOMAIN
        }/${this.$i18n.localePath()}/articles/${article.id}`
        : `https://${process.env.VUE_APP_MUZIK_READ}.${process.env.VUE_APP_MUZIK_DOMAIN}/${this.$i18n.localePath()}/`
    },
    eventHref(event) {
      return event && event.id
        ? `https://${process.env.VUE_APP_MUZIK_CONCERT}.${
          process.env.VUE_APP_MUZIK_DOMAIN
        }/${this.$i18n.localePath()}/events/${event.id}`
        : `https://${process.env.VUE_APP_MUZIK_CONCERT}.${process.env.VUE_APP_MUZIK_DOMAIN}/${this.$i18n.localePath()}/`
    },
    playlistHref(playlist) {
      return playlist && playlist.id
        ? `https://${process.env.VUE_APP_MUZIK_LISTEN}.${
          process.env.VUE_APP_MUZIK_DOMAIN
        }/${this.$i18n.localePath()}/playlists/${playlist.id}`
        : `https://${process.env.VUE_APP_MUZIK_LISTEN}.${process.env.VUE_APP_MUZIK_DOMAIN}/${this.$i18n.localePath()}/`
    }
  }
}
</script>
<style lang="scss" scoped>
@import '@/assets/scss/variables.scss';
.service {
  position: relative;
  margin-top: -40vh;
  margin-bottom: 90px;
  z-index: 1;
  .service-list {
    margin: 0 -18px;
    padding: 0;
    list-style: none;
    > li {
      display: inline-block;
      width: 33.33%;
      padding: 0 18px;
      float: left;
      .item {
        height: 390px;
        border-radius: 12px;
        box-shadow: 0 2px 30px 0 rgba(0, 0, 0, 0.27);
        // background-color: rgba(255, 255, 255, 0.5);
        background-repeat: no-repeat;
        background-position: center;
        background-size: cover;
        padding: 24px;
        &.listen,
        &.read,
        &.concert {
          .content {
            padding-top: 17px;
            ul {
              margin: 0;
              padding: 0;
              list-style: none;
              li {
                position: relative;
                padding: 7px 0;
                vertical-align: middle;
                i {
                  position: absolute;
                  top: 0;
                  bottom: 0;
                  margin: auto;
                  font-size: 12px;
                  height: 14px;
                  font-weight: normal;
                  color: $theme-yellow;
                  vertical-align: middle;
                }
                a {
                  display: inline-block;
                  width: 100%;
                  font-size: 16px;
                  color: $grey-50;
                  font-weight: bold;
                  line-height: 1.63;
                  padding-left: 20px;
                  text-decoration: none;
                  overflow: hidden;
                  text-overflow: ellipsis;
                  white-space: nowrap;
                  transition: .2s;
                  &:hover{
                    color: $link-hover;
                  }
                }
              }
            }
          }
        }
        &.read {
          background-image: url('/img/air/img-read.jpg');
        }
        &.concert{
          background-image: url('/img/air/img-concert.jpg');
        }
        &.listen {
          background-image: url('/img/air/img-listen.jpg');
        }
        >i {
          font-size: 64px;
          color: $theme-yellow;
          vertical-align: middle;
          margin-right: 4px;
        }
        .title {
          display: inline;
          font-size: 24px;
          font-weight: 500;
          font-stretch: normal;
          vertical-align: middle;
          line-height: 1.63;
          color: $grey-50;
          padding: 0;
          margin: 0;
        }
      }
    }
    &:after {
      content: '';
      display: block;
      clear: both;
    }
  }
}
@media only screen and (min-width: 1440px) {
}
@media only screen and (max-width: 1439.98px) {
  .service {
    margin-bottom: 34px;
    margin-top: -30vh;
    .service-list {
      margin: 0 -15px;
      > li {
        padding: 0 15px;
        .item {
          height: 295px;
          padding: 30px 14px;
          i {
            font-size: 48px;
          }
          .content {
            padding-top: 4px;
          }
          // &.listen {
          //   .content {
          //     .desp {
          //       margin: 4px 0;
          //     }
          //     .listen-player {
          //       margin: 5px auto 0;
          //     }
          //   }
          // }
          &.read,
          &.concert,
          &.listen {
            .content {
              padding-top: 4px;
              max-height: 200px;
              overflow: hidden;
              ul {
                li {
                  padding: 6px 0;
                }
              }
            }
          }
        }
      }
    }
  }
}
@media only screen and (max-width: 1023.98px) {
  .service {
    margin-bottom: 34px;
    margin-top: -175px;
    .service-list {
      > li {
        width: 100%;
        margin-bottom: 30px;
        .item {
          height: 220px;
          padding: 24px 14px;
          position: relative;
          i {
            font-size: 36px;
          }
          .title {
            font-size: 20px;
          }
          // &.listen {
          //   .content {
          //     padding-top: 32px;
          //     .listen-player {
          //       position: absolute;
          //       width: 120px;
          //       height: 120px;
          //       right: 10%;
          //       top: 0;
          //       bottom: 0;
          //       margin: auto;
          //     }
          //   }
          // }
          &.listen,
          &.read,
          &.concert {
            .content {
              max-height: 150px;
              padding-top: 8px;
              ul {
                li {
                  padding: 3px 0;
                }
              }
            }
          }
        }
        & + li {
          width: 50%;
          margin-bottom: 0;
        }
      }
    }
  }
}
@media only screen and (max-width: 767.98px) {
  .service {
    margin-top: -110px;
    .service-list {
      > li {
        width: 100%;
        margin-bottom: 24px;
        .item {
          height: 295px;
          &.listen,
          &.read,
          &.concert {
            .content {
              max-height: 280px;
            }
          }
        }
        & + li {
          width: 100%;
          margin-bottom: 24px;
        }
      }
    }
  }
}
</style>
